import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectAppLookAndFeelStore } from "_redux/app/app.selector";
import useModal from "./useModal";

const LOOK_AND_FEEL_KEY = "appLookAndFeel";

const useTabSync = () => {
  const { openModal } = useModal();

  const { data: appLookAndFeel } = useSelector(selectAppLookAndFeelStore);

  const workspaceName = useRef(null);
  const modalOpened = useRef(false);

  useEffect(() => {
    workspaceName.current = appLookAndFeel?.account?.name ?? workspaceName.current;
  }, [appLookAndFeel]);

  useEffect(() => {
    const handler = (e) => {
      // Workspace change: another tab wrote a different look & feel.
      // Session validation is handled only on mount (Routes.js init), so this
      // listener only reacts to workspace changes here.
      if (e.key !== LOOK_AND_FEEL_KEY) return;

      let newWorkspace;
      try {
        newWorkspace = JSON.parse(e.newValue)?.account?.name;
      } catch (err) {
        newWorkspace = undefined;
      }

      if (
        !modalOpened.current &&
        newWorkspace &&
        workspaceName.current &&
        newWorkspace !== workspaceName.current
      ) {
        modalOpened.current = true;
        openModal({
          typeModal: "workspaceChanged",
          isClosable: false,
          closeBackdrop: false
        });
      }
    };

    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useTabSync;
